







import { createComponent, ref, computed } from "@vue/composition-api";
import BasePostCodeInput from "./BasePostCodeInput.vue";
import { ValidationMessage } from "@web-components/types/ValidationMessage";

interface BasePostCodeInputProps {
  value?: string;
}

export default createComponent({
  props: {
    value: {
      required: false,
      type: String
    }
  },
  components: {
    BasePostCodeInput
  },
  setup(props: Readonly<BasePostCodeInputProps>, { emit }) {
    const isValid = ref(false);

    const localValue = computed({
      get: () => {
        return props.value;
      },
      set: val => {
        emit("input", val);
      }
    });

    const validationHandler = (input: ValidationMessage) => {
      emit("validation", input);
      isValid.value = input.valid;
    };

    return { isValid, localValue, validationHandler };
  }
});
